import apiClient from "../client";
const ENDPOINT = "/tokens"

export const tokensApi = {
    // getList: () => apiClient.get(ENDPOINT),
    // getDetail: (id) => apiClient.get(`${ENDPOINT}/${id}`),
    // create: (payload) => apiClient.post(ENDPOINT, payload),
    // update: (payload) => apiClient.patch(`${ENDPOINT}/${payload.id}`, payload),
    // delete: (id) => apiClient.delete(`${ENDPOINT}/${id}`),
    // userToken: () => apiClient.get(`${ENDPOINT}/my-tokens`),
    
    topup: (payload) => apiClient.post(`${ENDPOINT}/top-up`, payload),
};